import flamelink from "flamelink/app";
// Add additional modules that you want to use
import "flamelink/content";
import "flamelink/storage";

import { app as firebaseApp } from "@src/firebase.config";

export const app = flamelink({
  firebaseApp,
  dbType: "cf"
});
